export const Simulation = {
  getSimulatedLineItem: (item) => {
    let creative = null;
    if(item.creatives && item.creatives.length>0){
      creative = {
        adName: item.creatives[0].adsName,
        url: item.creatives[0].url,
        creative: item.creatives[0].creative,
        adStatus: item.creatives[0].status
      }
    }else{
      creative = {};
    }
    return {
      lineitemName: item.name,
      lineitemType: item.type,
      scheduleDuration: item.schedule,
      lineitemStatus: item.status,
      budgetPlanned: item.budgetPlanned,
      impressionsPlanned: item.impressionsPlanned,
      impressionDelivered: item.impressionDelivered,
      budgetDelivered: item.budgetDelivered,
      clicks: item.clicks,
      conversions: item.conversions,
      CPM: item.cpm,
      placementID: item.placement,
      deliveryType: item.delivery,
      frequency: item.frequencyCAP,
      recency: item.recency,
      adName: creative.adName,
      creativeName: creative.creative,
      adStatus: creative.adStatus
    };
  }
};
